import commonUtil from "../../../util/common-utils";
import { Actions } from "../../../constants/actions";

export interface SearchUserModalItem {
    id: string;
    displayName: string;
    reviewCount?: number;
    followersCount?: number;
    isFollowing?: boolean;
}

export interface SearchUserModalRenderParams {
    listRoot: HTMLElement;
    items: SearchUserModalItem[];
    selectedIds: Set<string>;
    isLoading: boolean;
}

export class SearchUserModalRender {
    public static render(params: SearchUserModalRenderParams): void {
        const { listRoot, items, selectedIds, isLoading } = params;

        if (isLoading) {
            listRoot.innerHTML =
                '<div class="search-user-modal__loading">' +
                '<div class="spinner spinner--inline-load" role="status" aria-hidden="true"></div>' +
                '<div class="search-user-modal__empty" data-translate="loading">Loading...</div>' +
                "</div>";
            return;
        }

        const rows = Array.isArray(items) ? items : [];
        if (rows.length === 0) {
            listRoot.innerHTML = '<div class="search-user-modal__empty" data-translate="search_no_users">-</div>';
            return;
        }

        listRoot.innerHTML = rows
            .map((user) => {
                const id = String(user.id || "");
                const name = String(user.displayName || id);
                const reviewCount = Number.isFinite(Number(user.reviewCount)) ? Number(user.reviewCount) : 0;
                const followersCount = Number.isFinite(Number(user.followersCount)) ? Number(user.followersCount) : 0;
                const isSelected = selectedIds.has(id);
                const selectedAttrs = isSelected ? ' data-selected="1" aria-pressed="true"' : ' aria-pressed="false"';
                const selectedClass = isSelected ? " search-user-option--selected" : "";
                const followingClass = user.isFollowing
                    ? " search-user-option--following"
                    : " search-user-option--muted";

                return `<button type="button" class="search-user-option${selectedClass}${followingClass}" data-action="${Actions.SELECT_USER}" data-user-id="${commonUtil.escapeHtmlAttribute(
                    id,
                )}"${selectedAttrs}>
                    <span class="search-user-option__name">${commonUtil.escapeHtml(name)}</span>
                    <span class="search-user-option__meta">
                        (<i class="bi bi-chat-left-text"></i> ${commonUtil.escapeHtml(
                            String(reviewCount),
                        )} <i class="bi bi-people"></i> ${commonUtil.escapeHtml(String(followersCount))})
                    </span>
                </button>`;
            })
            .join("");
    }
}
